/**
 * Tells whether an upload operation is waiting for review: its latest worker message is done/operationcomplete.
 * Its documents are saved by then, so after a reload the tab reattaches to it instead of resurrecting it
 * (DE-1730, ADR-0010).
 *
 * @param {object} operation - The operation, with its worker messages.
 * @returns {boolean} true if the operation is waiting for review.
 */
export const isReviewPending = (operation) => {
    const latest = operation?.workerMessages?.at(-1);
    return latest?.status === 'done' && latest?.id === 'operationcomplete';
};
